let drawer_cart = document.getElementsByClassName("cart_wrapper")[0];
let cart_overflow = document.getElementById("cart_items");
let body = document.getElementsByTagName("body")[0];
let container = document.getElementsByClassName("cart_container_drower")[0];
let out_in_stock = document.getElementsByClassName("out_in_stock")[0];
let string = document.querySelector("#all_variant_track").innerHTML;
let stringGifts = document.querySelector("#all_variant_track_gifts").innerHTML;
let cart_upsell = document.getElementsByClassName("upsell")[0];
let currencySymbol = document.querySelector("body").dataset.currencysymbol;
let btnCheckout =  document.querySelector(".footer_button_checkout");
let drawer_container = document.querySelector(".cart_wrapper")
let nextSlider;
let giftArrayProduct;

// upsell 
let JsonUpsell = JSON.parse(document.querySelector("#upsell__product").innerHTML) ? JSON.parse(document.querySelector("#upsell__product").innerHTML) : false;
// Gift dataset
let giftAdded = parseInt(document.querySelector('.gift--modal__items').dataset.added);
let giftMinPriceAdded = parseInt(document.querySelector('.gift--modal__items').dataset.minPrice);

let giftAddedMedium = parseInt(document.querySelector('.gift--modal__items').dataset.addedMedium);
let giftMinPriceAddedMedium = parseInt(document.querySelector('.gift--modal__items').dataset.addedPriceMedium);

let giftAddedHigh = parseInt(document.querySelector('.gift--modal__items').dataset.addedHigh);
let giftMinPriceAddedHigh = parseInt(document.querySelector('.gift--modal__items').dataset.addedPriceHigh);

// Gift collection
let buttonOpenModal = document.querySelector('.drawer_modal_open button');
let giftCollection = document.querySelector('#gift__products').innerHTML;
let giftHeader = document.querySelector('.gift--number__header span');
let giftSubtitle = document.querySelector('.gift--number__footer span');
let giftHeaderShow = document.querySelector('.gift--number__header');
let giftHeaderShowOne = document.querySelector('.gift--number__header_one');
const JsonObject = JSON.parse(giftCollection);
// modal variables
let modalBtn = document.querySelector('.drawer_modal_open button');
let modalContent = document.querySelector('#cart-gift__modal');
let modalClose = document.querySelector('.gift--modal__close');
let modalBackdrop = document.querySelector('.cart-gift__backdrop');
let giftSwiperItem = document.querySelectorAll('.gift_swiper-slide');

giftSwiperItem.forEach(el => {
    el.addEventListener('click', function () {
        modalContent.classList.add('in');
        deleteGiftProductWithModal();
        checkItemInCart();
    });
})

modalBtn.addEventListener('click', function () {
    modalContent.classList.add('in');
});
modalClose.addEventListener('click', function () {
    modalContent.classList.remove('in');
});
modalBackdrop.addEventListener('click', function () {
    modalContent.classList.remove('in');
});
const countHeader = () => {
    let valueQuantity = 0;
    let quantitiesInputs = document.querySelectorAll('.gift--modal__quantity .quantity_selector input');
    quantitiesInputs.forEach((quantity) => {
        valueQuantity += parseInt(quantity.value);
    });

    let giftItemsTotal = document.querySelector('.gift--modal__items').dataset.totalPrice;
    if (giftItemsTotal > giftMinPriceAddedHigh) {
        giftHeader.innerHTML = giftAddedHigh.toString();
    }else if (giftItemsTotal > giftMinPriceAddedMedium) {
        giftHeader.innerHTML = giftAddedMedium.toString();
    }else if (giftItemsTotal > giftMinPriceAdded) {
        giftHeader.innerHTML = giftAdded.toString();
    }

    giftSubtitle.innerHTML = valueQuantity;
}
//functions
const handleAddToCart = (el, flag) => {
    let varId

    if(el.dataset.variantId){
        varId = el.dataset.variantId
    }else{
      varId = flag
        ? document.getElementById(`varId-${el.dataset.inputid}`).value
        : window.location.search.substr(1).split("variant=")[1].split('&')[0] || document.getElementById(`varId-${el.dataset.inputid}`).value;
    }


    let quantity =
        document.getElementById(
            `product_quantity-${window.location.search.substr(1).split("=")[1]}`
        )?.value || 1;
    let productParams = JSON.parse(string)
        .split(varId)[1]
        .split(",")[0]
        .split(":")[1]
        ?.split("}")[0];
    let selling_state = productParams.split("-")[1].split('"')[0];
    let availableQuantity = productParams.split("-")[0].split('"')[1];
    let formData = {
        items: [
            {
                id: +varId,
                quantity: +quantity,
            },
        ],
    };

    fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            return response.json();
        })
        .then((el) => {
            if (selling_state === "deny") {
                if (+quantity > +availableQuantity) {
                    out_in_stock.style.display = "unset";
                    out_in_stock.innerHTML = `Available quantity on stock - ${availableQuantity}`;
                } else {
                    if (el.items.length == 0) {
                        if (+quantity > +availableQuantity) {
                            out_in_stock.style.display = "unset";
                            out_in_stock.innerHTML = `Available quantity on stock - ${availableQuantity}`;
                        } else {
                            addToCartRequest(formData);
                        }
                    } else {
                        let product = el.items.find(
                            ({variant_id}) => variant_id === +varId
                        );
                        if (
                            product?.quantity == +availableQuantity ||
                            product?.quantity + formData.items[0].quantity >
                            +availableQuantity
                        ) {
                            out_in_stock.innerHTML = `Available quantity on stock - ${availableQuantity}`;
                            out_in_stock.style.display = "unset";
                        } else {
                            addToCartRequest(formData);
                        }
                    }
                }
            } else {
                addToCartRequest(formData);
            }
        })
        .catch((error) => {
            console.error("Error:", error);
        });

};
const addToCartRequest = (formData) => {
    out_in_stock.style.display = "none";

    fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
    })
        .then((response) => {
            openCart();
            return response.json();
        })
        .catch((error) => {
            console.error("Error:", error);
        });
};
// const getCartItems = () => {
//     let upsellArr = [];
//     let productsTag = [];
//     fetch(window.Shopify.routes.root + "cart.js", {
//         method: "GET",
//         headers: {
//             "Content-Type": "application/json",
//         },
//     })
//         .then((response) => {
//             return response.json();
//         })
//         .then((el) => {
//             findProductByHandle(el, upsellArr, productsTag);
//             drawItems(el);
//             drawModal(el);
//             drawUpsell(el);
//             checkModalItems(el);
//             changePriceHeading();
//             checkDelivery();
//             toggleModeSelect();
//             checkGiftProduct();
//             checkCountSelectProduct();
//             getSelectProduct(document.querySelector(".select_product"), document.querySelectorAll(".checkbox_fake.isChecked"));
//             removeDisabledBtn();
//             checkProgressBar();
//         })
//         .catch((error) => {
//             console.error("Error:", error);
//         })

// };

// const updateItem = (id, qty) => {
//     let upsellArr = [];
//     let productsTag = [];
//     document
//         ?.getElementById(`quantity_minus-${id}`)
//         .classList.add("disabled_button");
//     document
//         ?.getElementById(`quantity_plus-${id}`)
//         .classList.add("disabled_button");
//     document.getElementById(`loaderId-${id}`).style.display = "unset";

//     let formData = {
//         updates: {
//             [`${id}`]: qty,
//         },
//     };
//     toggleDisabledBtn(true)
//         let x = fetch(window.Shopify.routes.root + "cart/update.js", {
//             method: "POST",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify(formData),
//         })
//         .then((response) => {
//             return response.json();
//         })
//         .then((el) => {
//             findProductByHandle(el, upsellArr, productsTag);
//             drawItems(el);
//             drawModal(el);
//             drawUpsell(el);
//             checkModalItems(el);
//             changePriceHeading();
//             checkDelivery();
//             toggleModeSelect();
//             checkGiftProduct();
//             checkCountSelectProduct();
//             getSelectProduct(document.querySelector(".select_product"), document.querySelectorAll(".checkbox_fake.isChecked"));
//             removeDisabledBtn();
//             checkProgressBar();
//             getGiftArr(el);
//             if (qty !== 0) {
//                 document.getElementById(`loaderId-${id}`).style.display = "none";
//             }    
//         })
//         .catch((error) => {
//             console.error("Error:", error);
//         }).finally( ()=> {
//             setTimeout(toggleDisabledBtn(false), 500);
//         })
//         console.log('====================================');
//         console.log(Promise(x));
//         console.log('====================================');

//         // checkGiftProduct();
// };
const getCartItems = async () => {
    let upsellArr = [];
    let productsTag = [];
  
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const el = await response.json();
  
      findProductByHandle(el, upsellArr, productsTag);
      drawItems(el);
      drawModal(el);
      drawUpsell(el);
      checkModalItems(el);
      changePriceHeading();
      checkDelivery();
      toggleModeSelect();
      checkGiftProduct();
      checkCountSelectProduct();
      getSelectProduct(
        document.querySelector(".select_product"),
        document.querySelectorAll(".checkbox_fake.isChecked")
      );
      removeDisabledBtn();
      checkProgressBar();
    } catch (error) {
      console.error("Error:", error);
    }
  };
  
const updateItem = async (id, qty) => {
    let upsellArr = [];
    let productsTag = [];
    document
      ?.getElementById(`quantity_minus-${id}`)
      .classList.add("disabled_button");
    document
      ?.getElementById(`quantity_plus-${id}`)
      .classList.add("disabled_button");
    document.getElementById(`loaderId-${id}`).style.display = "unset";
  
    let formData = {
      updates: {
        [`${id}`]: qty,
      },
    };
    toggleDisabledBtn(true);
  
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const el = await response.json();
  
      findProductByHandle(el, upsellArr, productsTag);
      drawItems(el);
      drawModal(el);
      drawUpsell(el);
      checkModalItems(el);
      changePriceHeading();
      checkDelivery();
      toggleModeSelect();
      checkGiftProduct();
      checkCountSelectProduct();
      getSelectProduct(
        document.querySelector(".select_product"),
        document.querySelectorAll(".checkbox_fake.isChecked")
      );
      removeDisabledBtn();
      checkProgressBar();
      getGiftArr(el);
      if (qty !== 0) {
        document.getElementById(`loaderId-${id}`).style.display = "none";
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setTimeout(() => toggleDisabledBtn(false), 1000);
    }  
  };
  
const updateItemModal = (btn, el) => {
    let modalQuantities = document.querySelectorAll('.gift--modal__quantity .quantity_selector button');
    let modalInputQuantities = document.querySelectorAll('.gift--modal__quantity .quantity_selector input');
    if (btn.name === 'minus') {
        let minus = btn.nextElementSibling;
        let count = parseInt(minus.value) - 1;
        count = count < 0 ? 0 : count;
        minus.value = count;
        minus.dispatchEvent(new Event('change'));
        minusItem(btn, modalQuantities, modalInputQuantities);
        return false;
    }

    if (btn.name === 'plus') {
        let plus = btn.previousElementSibling;
        plus.value = parseInt(plus.value) + 1;
        plus.dispatchEvent(new Event('change'));
        plusItem(btn, modalQuantities, modalInputQuantities);
        return false;
    }
}
const drawModal = (el) => {
    let giftItems = document.querySelector('.gift--modal__items');
    let totalPrice = getPrice("#total_checkout_price");
    giftItems.dataset.totalPrice = (totalPrice / 100).toFixed(2);
    giftItems.innerHTML = '';

    for (let product in JsonObject.products) {
        let title = JsonObject.products[product].title;
        let available = JsonObject.products[product].available;
        let image = JsonObject.products[product].image;
        let metafieldPrice = JsonObject.products[product].metafield_price;
        let selectedVariant = JsonObject.products[product].selected_variant;
        let fakePrice = JsonObject.products[product].metafield_fake;
        let variantIdLoad = 0;

        let totalPrice = parseInt((el.total_price / 100).toFixed(2));
        let opacityClass = totalPrice < metafieldPrice ? "opacity__gift" : '';

        el.items.forEach((item,index) => {
            if (parseInt(item.variant_id) === parseInt(selectedVariant)) {
                variantIdLoad = totalPrice > parseFloat(metafieldPrice) ? variantIdLoad = item.quantity : variantIdLoad = 0;
            }
        });

        if (available === 'true') {
            let block = metafieldPrice ? `<div onclick="handleCheckbox(this)" data-id=${selectedVariant} class="gift--modal__item ${opacityClass}  ${checkGiftProductIsCart(selectedVariant)} ">
                                <div class="gift--modal__image">
                                    <img src="${image}"
                                         alt="${title}">
                                </div>
                                <div class="gift--modal__title--item">
                                    <span class="gift__title">${title}</span>
                                    <p class="gift__badge">
                                        <span class="gift__badge-price">${fakePrice !== "" ? fakePrice + currencySymbol : "29.00" + currencySymbol }</span>
                                        <span class="gift__badge-badge">Gratis</span>
                                    </p>
                                </div>
                                <div class="gift--modal__checkbox">
                                    <div class="checkbox_fake" data-giftid=${selectedVariant}>
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.11397 11.0772L0.256827 6.69791C-0.171745 6.26858 -0.0860304 5.58163 0.428255 5.23816C0.942541 4.89469 1.71397 4.98056 2.05683 5.4099L4.02826 7.64246L9.94254 0.429578C10.2854 0.000239483 10.9711 -0.171496 11.4854 0.171975C11.9997 0.515445 12.0854 1.11652 11.7425 1.63172L4.11397 11.0772Z" fill="white"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="gift--modal__quantity">
                                    <quantity-input class="quantity_selector qty_sel" data-metafield-price="${metafieldPrice}">
                                        <button id="${selectedVariant}"
                                                onclick="updateItemModal(this)"
                                                name="minus"
                                                type="button">-</button>
                                        <input id="${selectedVariant}"
                                               class="quantity_input_drawer__modal" type="text" name="updates[]"
                                               readonly="false" value="0" min="0" max="1">
                                        <button id="${selectedVariant}"
                                                onclick="updateItemModal(this)"
                                                name="plus"
                                                type="button">+</button>
                                    </quantity-input>
                                </div>
                            </div>` : '';
            giftItems.innerHTML += block;
        }
    }

    let modalInputQuantities = document.querySelectorAll('.gift--modal__quantity .quantity_selector input');
    let giftItemsTotal = document.querySelector('.gift--modal__items').dataset.totalPrice;
    let counter = counterProducts();

    let valueQuantity = 0;

    modalInputQuantities.forEach((quantity, quantityIndex) => {
        valueQuantity += parseInt(quantity.value);
        giftSubtitle.innerHTML = valueQuantity;

        giftItemsTotal = parseInt(giftItemsTotal);

        if (valueQuantity === counter) {
            modalInputQuantities.forEach((quantityValue) => {
                quantityValue.nextElementSibling.setAttribute('disabled', 'true');
                if (parseInt(quantityValue.value) === 0) {
                    // quantityValue.parentElement.parentElement.parentElement.classList.add('opacity__gift');
                } else {
                    quantityValue.parentElement.parentElement.parentElement.classList.remove('opacity__gift');
                }
            });
        }
    });

    countHeader();
}
const checkModalItems = (el) => {
    let updateData = {updates: {}}
    let giftItems = document.querySelector('.gift--modal__items');
    let totalPrice = parseFloat(el.total_price);
    totalPrice = giftItems.dataset.totalPrice = (totalPrice / 100).toFixed(2);
    el.items.forEach((product, i, array) => {
        JsonObject.products.forEach((item) => {
            if (parseInt(item.selected_variant) === parseInt(product.variant_id)) {
                let metafieldPrice = item.metafield_price;
                if (totalPrice < parseFloat(metafieldPrice)) {
                    updateData.updates[product.variant_id] = 0
                }
            }

        });
    });

    totalPrice < giftMinPriceAdded ? buttonOpenModal.classList.add('none') : buttonOpenModal.classList.remove('none');
    totalPrice < giftMinPriceAdded ? giftHeaderShow.classList.add('none') : giftHeaderShow.classList.remove('none');
    totalPrice > giftMinPriceAdded ? giftHeaderShowOne.classList.add('none') : giftHeaderShowOne.classList.remove('none');

    if (Object.keys(updateData)?.length) {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updateData)
        }).then(function (response) {
            return response.json();
        }).then(function (newEl) {
            // getCartItems();
            drawItems(newEl);
        }).catch(function (err) {
        });
    }
}
const drawItems = (el) => {
    document.querySelector(".cart_container_drower").classList.remove("isEmptyCart")
    document.querySelector(".cart_container_drower").classList.add("isActiveCart")
    cart_overflow.innerHTML = "<div></div>";
    document.getElementById("cart_count").innerHTML = el?.item_count;
    let drawerModalOpen = document.querySelector('.drawer_modal_open');
    let product_item;
    toggleDisabledBtn(true);
    if (el.item_count > 0) {
        let shipping_bar_id = document.getElementById("shipping_bar_id");
        let shipping_bar_container = document.getElementById(
            "shipping_bar_container"
        );
        let need_to_pay = document.getElementById("need_to_pay");
        let shipping_title = document.getElementById("shipping_title");

        document.getElementById("cart_footer").style.display = "unset";
        document.getElementById("total_checkout_price").textContent =
            (el?.total_price / 100).toFixed(2) + " " + currencySymbol;
        drawerModalOpen.style.display = "block";
        cart_upsell.style.display = "unset";
        shipping_bar_id.style.display = "flex";
        shipping_bar_container.style.display = "block";
        setTimeout(() => toggleDisabledBtn(false), 1000);

        return el?.items.map((data) => {
            const productsData = string.includes(data.variant_id) ? string : stringGifts;
          
            let productParams = JSON.parse(productsData)
                .split(data.variant_id)[1]
                .split(",")[0]
                .split(":")[1]
                .split("}")[0];
            let productCap = productParams.split("cap=")[1].split("=")[0];
            let availableQuantity = productParams.split("-")[0].split('"')[1];
            let selling_state = productParams.split("-")[1].split('"')[0];

            if (!productCap && data.final_line_price !== data.original_price) {
                productCap = data.original_price;
            }

            product_item = document.createElement("div").innerHTML =
                `<div data-id="${data.variant_id}"  data-gift=${findPopUpItems(data.variant_id) ? "true" : "false" } class="cart_item" data-carttitle="${data.product_title}">
                    <div class="item--loadbar" id="loaderId-${data.variant_id}">
                      <div class="loaderCart">&nbsp;</div>
                    </div>
                    <div class="item_wrapper">
                      <div class="info_box">  
                        <div class="image ${findPopUpItems(data.variant_id) ? "image_gift" : "" } " > 
                          <img 
                            height="60"
                            width="60"
                            src=${data.featured_image.url}
                            alt=${data.featured_image.alt}
                            loading="lazy"
                          >
                        </div>
                        <div class="info_item_title"> 
                         ${findPopUpItems(data.variant_id) ? `<p>${data.product_title}</p>`: `<a href=${data.url}>${data.product_title}</a>`}
                        ${findPopUpItems(data.variant_id) || findUpsellItems(data.variant_id) ? 
                            `<quantity-input style="display: none"  class="quantity_selector qty_sel">
                                                    <button onclick="updateItem(${data.variant_id},${
                                    data.quantity - 1
                                })" id='quantity_minus-${
                                    data.variant_id
                                }' class="no-js-hidden" name="minus" type="button">
                                                                            <span></span> -
                                                    </button>
                                                    <input
                                                        class='quantity_input_drawer'
                                                        type="text"
                                                        name="updates[]"
                                                        readonly='false'
                                                        value=${data.quantity}
                                                        min="0"
                                                        id=${data.variant_id}
                                                    />
                                                    <button onclick="updateItem(${data.variant_id},${
                                    data.quantity + 1
                                })" id='quantity_plus-${
                                    data.variant_id
                                }' class="no-js-hidden" name="plus" type="button">
                                                                            <span class="visually-hidden"></span>
                                                                            +
                                                    </button>
                                </quantity-input>`
                            : `<quantity-input class="quantity_selector qty_sel">
                                                    <button onclick="updateItem(${data.variant_id},${
                                    data.quantity - 1
                                })" id='quantity_minus-${
                                    data.variant_id
                                }' class="no-js-hidden" name="minus" type="button">
                                                                            <span></span> -
                                                    </button>
                                                    <input
                                                        class='quantity_input_drawer'
                                                        type="text"
                                                        name="updates[]"
                                                        readonly='false'
                                                        value=${data.quantity}
                                                        min="0"
                                                        id=${data.variant_id}
                                                    />
                                                    <button onclick="updateItem(${data.variant_id},${
                                    data.quantity + 1
                                })" id='quantity_plus-${
                                    data.variant_id
                                }' class="no-js-hidden" name="plus" type="button">
                                                                            <span class="visually-hidden"></span>
                                                                            +
                                                    </button>
                                </quantity-input>`
                            }
                        </div>     
                      </div>
                        <div class="item_actions_wrapper">
                          <div class="upsell_price_wrapper_UT"> 
                            <div class="upsell_cap_price_UT" id=cap_price-${data.variant_id}> 
             ${!isNaN(productCap) && +productCap
                    ? ((+productCap / 100) * data.quantity).toFixed(2).replace(".", ",") +
                    currencySymbol
                    : ""}
            </div>
                                ${findPopUpItems(data.variant_id) 
                                    ?`<div class="upsell_price_UT">   
                                        <strong class='final_price_fake'>${getFakePrice(data.variant_id)}</strong> 
                                        <span class='final_price_badge'>Gratis</span>
                                     </div>`
                                    :`<div class="upsell_price_UT">   
                                        <strong class='final_price'>
                                            ${(data.final_line_price / 100).toFixed(2).replace(".", ",") + currencySymbol}
                                        </strong>     
                                    </div>`
                                }
                                </div>
                           <div class="info_drawer cart_info_drawer">
                                <div class="actions">
                                    <div class="remoove">
                                    <cart-remove-button>
                                            <button class="remoove_button" onclick="updateItem(${data.variant_id},0)">
                                                                    <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                                                                         xmlns="http://www.w3.org/2000/svg">
                                                                        <path
                                                                            d="M14.3265 3.42857H11.3878V2.81633V2.32653C11.3878 0 10.2857 0 9.18367 0C8.08163 0 7.95918 0 5.7551 0C3.55102 0 3.42857 1.10204 3.42857 2.32653C3.42857 2.81633 3.42857 2.81633 3.42857 2.81633V3.42857H0.612245C0.244898 3.42857 0 3.67347 0 4.04082V5.14286C0 5.5102 0.244898 5.7551 0.612245 5.7551C0.979592 5.7551 1.22449 6 1.22449 6.36735V17.3878C1.22449 17.7551 1.46939 18 1.83673 18H13.3469C13.7143 18 13.9592 17.7551 13.9592 17.3878V6.36735C13.9592 6 14.2041 5.7551 14.5714 5.7551C14.9388 5.7551 15.1837 5.5102 15.1837 5.14286V4.04082C14.9388 3.67347 14.6939 3.42857 14.3265 3.42857ZM4.77551 1.46939H9.91837V3.55102H4.77551V1.46939ZM12.2449 15.4286C12.2449 15.9184 11.8776 16.2857 11.3878 16.2857H3.55102C3.06122 16.2857 2.69388 15.9184 2.69388 15.4286V6.61225C2.69388 6.12245 3.06122 5.7551 3.55102 5.7551H11.5102C12 5.7551 12.3673 6.12245 12.3673 6.61225V15.4286H12.2449Z"
                                                                            fill="#444444"/>
                                                                    </svg>
                                                                </button>
                                        </cart-remove-button>
                                    </div>
                                </div>
                            </div>
                          </div>
                      </div>
                </div>`;

            cart_overflow.innerHTML += product_item;
            if (selling_state === "deny") {
                if (+data.quantity == +availableQuantity) {
                    document
                        ?.getElementById(`quantity_plus-${data.variant_id}`)
                        ?.classList.add("disabled_button");
                }
            }
            if (el.total_price.toFixed(2) / 100 < shipping_bar_id.max) {
                shipping_bar_id.value = el.total_price.toFixed(2) / 100;

                need_to_pay.innerHTML =
                    "Añade " +
                    (shipping_bar_id.max - el.total_price.toFixed(2) / 100).toFixed(2) +
                    currencySymbol;

                shipping_title.innerHTML = "para tener Envío Gratis";
            } else {
                shipping_bar_id.value = el.total_price.toFixed(2) / 100;
                shipping_title.innerHTML =
                    "¡Enhorabuena! Ya tienes el <strong>Envío Gratis</strong> ";
                need_to_pay.innerHTML = "";
            }
        });
    } else {
        document.querySelector(".cart_container_drower").classList.add("isEmptyCart")
        document.querySelector(".cart_container_drower").classList.remove("isActiveCart")
        drawerModalOpen.style.display = "none";
        cart_upsell.style.display = "none";
        shipping_bar_id.style.display = "none";
        shipping_bar_container.style.display = "none";
        product_item = document.createElement("div").innerHTML = `
      <div class='empty_cart_box checkout_button'>
        <h2 class='empty_title'>Tu carrito está vacío</h2>
      </div>`;
        document.getElementById("cart_footer").style.display = "none";
        cart_overflow.innerHTML += product_item;
        document.getElementById("total_checkout_price").textContent = 0.00;
        setTimeout(() => toggleDisabledBtn(false), 1000);
    }
};
const findPopUpItems = (id) => {
    return JsonObject.products.find((item) => parseInt(item.selected_variant) === id);
}
const findUpsellItems = (id) => {
    if (JsonUpsell) {
       return JsonUpsell.some(el => el.id == id );
    }
}
const applyDiscountCode = async () => {
    const scDiscountApp = document.querySelector('#scDiscountApp .sc_simple-container');
    const couponCodeSvg = document.querySelector('.icart-coupon-code-svg');
    const discountContainer = document.querySelector('.scDiscount__container');
    if (!scDiscountApp) {
        try {
            const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if (data.item_count !== 0 && data.cart_level_discount_applications.length !== 0) {
                const couponCode = data.cart_level_discount_applications[0].title;
                const couponCodeInput = document.querySelector('#code');
                const submitButton = document.querySelector('#submit');


                if (couponCodeInput && submitButton) {
                    couponCodeInput.value = couponCode;
                    DiscountHero.discount.apply(couponCode);
                }

                if (couponCodeSvg) {
                    couponCodeSvg.classList.add('isActive');
                }

                if (discountContainer) {
                    discountContainer.classList.add('isActive');
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }else{
        if (couponCodeSvg) {
            couponCodeSvg.classList.add('isActive');
        }

        if (discountContainer) {
            discountContainer.classList.add('isActive');
        }
    }
};
const popUpDiscount = () =>{
    let nmgTemplate = '';
    let idNmg = 0;

    let nmgSection = setInterval(() => {
        idNmg++;
        nmgTemplate = document.querySelector('nmg-templates');
        if(idNmg !== 10) {
            if (nmgTemplate) {
                nmgTemplate.parentElement.style.zIndex = '999'
                clearInterval(nmgSection);
            }
        }
    }, 1000)
}

const openCart = () => {
    popUpDiscount();
    getCartItems();
    applyDiscountCode();
    // handleChangeDiscoutnPosition();
    drawer_cart.classList.add("active_drawer");
    body.classList.add("overflow-hidden");
    // body.classList.add("_disabled_scroll");
    drawer_container.classList.remove("drawer_closed")
    drawer_cart.style.display = "flex";

    if (document.querySelector("#code")?.value) {
        document.querySelector("#submit")?.click();
    }

    setTimeout(() => {
        container.style.transform = "translate(0%)";
    }, 200);
    setTimeout(() => {
        cart_upsell.style.transform = "translate(0%)";
    }, 350);
    
    nextSlider = setInterval(() => {
        if (document.querySelector(".top_swiper-next")) {
            document.querySelector(".top_swiper-next").dispatchEvent(new Event("click"))
        }
    }, 3000);
};
const outsideClick = () => {
    const specifiedElement = document.getElementById("outside_overlay");
    document.addEventListener("click", (event) => {
        if (event.target.id === specifiedElement.id) {
            closeCart();
        }
    });
};
const closeCart = () => {
    clearInterval(nextSlider)
    setTimeout(() => {
        cart_upsell.style.transform = "translate(100%)";
    }, 200);
    setTimeout(() => {
        container.style.transform = "translate(100%)";
    }, 400);
    setTimeout(() => {
        drawer_cart.style.display = "none";
        drawer_cart.classList.remove("active_drawer");
        body.classList.remove("overflow-hidden");
        body.classList.remove("_disabled_scroll");
        drawer_container.classList.add("drawer_closed")

    }, 550);

};
const changeUpsellVariant = (el) => {

    let itemWrapper = el.closest(".product_item");
    let productObjWrapper = el
        .closest(".product_item")
        .querySelector(".product_object").innerHTML;
    let productObj = JSON.parse(productObjWrapper).product.variants;
    let variantTitle = "";
    itemWrapper.querySelectorAll("form select").forEach((select) => {
        variantTitle += variantTitle == "" ? select.value : " / " + select.value;
    });
    for (let i = 0; i < productObj.length; i++) {
        if (variantTitle == productObj[i].title) {
            document.getElementById(`varId-${el.id}`).value = productObj[i].id;
            if (productObj[i].featured_image) {
                el.closest(".product_item").querySelector(".upsell_img").src =
                    productObj[i].featured_image.src;
            }

            el.closest(".product_item").querySelector(".upsell_price_UT").innerHTML =
                (productObj[i].price / 100).toFixed(2) + currencySymbol;

            el
                .closest(".product_item")
                .querySelector(".upsell_cap_price_UT").innerHTML =
                +productObj[i].compare_at_price > 0
                    ? (productObj[i].compare_at_price / 100).toFixed(2) + currencySymbol
                    : "";
        }
    }
};
const drawUpsell = (el) => {
    let upsell_wrapper = document.getElementById("upsell_wrapper");
    let upsellId = [];
    let upsellUniqId = [];
    let upsellTitle = [];
    let cartItems = [];
    let htmlEl = [];
    let upsellUniqItems = [];
    cart_upsell.style.display = "none";

    function handleResponse() {
        let divEl = document.createElement("div");
        divEl.innerHTML = this.responseText;
        let upsell_box = divEl.querySelectorAll(".product_item");
        //  "Product data from upesll, uniq id and html elements with id"
        upsell_box.forEach((element) => {
            upsellId.push(+element.dataset.metafield_id);
            htmlEl.push({id: element.dataset.metafield_id, element: element});
        });
        // "get ids items from cart and set in array";
        el.items.forEach((element) => {
            upsellTitle.push(element.title.split(" -")[0]);
            cartItems.push(element.id);
        });

        // "filter upsellIDs and get only uniq values";
        upsellUniqId = upsellId.filter((value, index, self) => {
            return !cartItems.includes(self.indexOf(value) === index);
        });

        //  "filter HTMLs elements and get only uniq"
        for (let i = 0; i < upsellUniqId.length; i++) {
            const item = htmlEl[i];
            for (let j = 0; j < upsellUniqId.length; j++) {
                const element = upsellUniqId[j];

                if (+item.id === element) {
                    upsellUniqItems.push(item);
                    break;
                }
            }
        }
        upsellUniqItems = htmlEl.filter((data, index) => {
            return upsellUniqId.indexOf(+data.id) === index;
        });
        // filter upsell by same title
        upsellUniqItems = upsellUniqItems.filter((data) => {
            return !upsellTitle.includes(data.element.dataset.producttitle);
        });

        // "filter cart and upsell items and remoove frome upsell if find same with cart"
        if (upsell_wrapper.dataset.upsellvariants === "false") {
            upsellUniqItems = upsellUniqItems.filter((data) => {
                return !cartItems.includes(+data.id);
            });
        }

        upsell_wrapper.innerHTML = "";
        upsellUniqItems.map(({element}) => {
            upsell_wrapper.appendChild(element);
        });
        if (!upsellUniqItems.length) {
            cart_upsell.style.display = "none";

        } else {
            cart_upsell.style.display = "unset";
        }
        cart_upsell.style.display = "unset";
    }


    // get upsell products and call draw function
    const request = new XMLHttpRequest();
    request.addEventListener("load", handleResponse);
    request.open("GET", "/?snippets=UTcart", true);
    request.send();
};
// const findProductByHandle = (el, upsellArr, productsTag) => {
//     let productsWithTags = [];
//     if (allProducts) {
//         let { items } = el;        
//         [...items].filter((el) => {
//           for (let obj of allProducts) {
//             for (let [key, value] of Object.entries(obj)) {
//               if (+key === +el.id) {

//                 productsWithTags.push(value['tags'].toString().replaceAll("&&",","));
//                 return true; 
//               }
//             }
//           }
//           return false;
//         });
//     } else {
//         el.items.map(({handle}) => {
//         fetch(window.Shopify.routes.root + `products/${handle}.js`, {
//             headers: {
//                 "Content-Type": "application/json",
//             },
//         })
//             .then((response) => {
//                 return response.json();
//             })
//             .then((product) => {
//                 productsWithTags.push(product);
//             })
//             .catch((error) => {
//                 console.error("Error:", error);
//             });
//     });
//     }

//     setTimeout(() => {

//     console.log('====================================');
//     console.log(productsWithTags);
//     console.log('====================================');
//         findUpsellProductByHandle(productsWithTags, upsellArr, productsTag);
//     }, 400);
// };


const findProductByHandle = async (el, upsellArr, productsTag) => {
    try {
      let productsWithTags = [];
      const fetchPromises = el.items.map(({ handle }) => {
        return fetch(window.Shopify.routes.root + `products/${handle}.js`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((product) => {
            productsWithTags.push(product);
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      });
  
      await Promise.all(fetchPromises);
  
        findUpsellProductByHandle(productsWithTags, upsellArr, productsTag);
    } catch (error) {
      console.error("Error:", error);
    }
};
const findUpsellProductByHandle = (product, upsellArr, productsTag) => {
    product.map(({tags}) => {
            console.log(tags);
            tags.map((tag) => {
                if (tag.includes("upsell")) {
                    upsellArr.push(tag);
                }
            });
        });
    
    product.map(({tags}) => {
            tags.map((tag) => {
                productsTag.push(tag);
            });
    });
    upsellArr.map((data) => {
        if (productsTag.indexOf(`${data.replace("-upsell", "")}-main`) === -1) {
            removeUnusedUpsellProduct(data);
        }
    });
};
const removeUnusedUpsellProduct = (handle) => {
    if (handle?.includes("upsell")) {
        toggleDisabledBtn(true)
        fetch(window.Shopify.routes.root + `products/${handle}.js`, {
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => {
                return response.json();
        })
        .then((product) => {
            product.variants.map((data) => {
                document.querySelectorAll(".item--loadbar").forEach((el) => {
                    if (data.id === +el.id.split("-")[1]) {
                            updateItem(data.id, 0);
                        }
                    });
            });
        })
        .catch((error) => {
                console.error("Error:", error);
        }).finally(()=> {
            setTimeout(toggleDisabledBtn(false), 1000);
        })
    }
};
const modalAddProducts = (event) => {
    getAllCartItems();
    modalContent.classList.remove('in');
}

function getGiftArr(obj) {
    const { items } = obj;
    const giftArrayProduct = [...items].filter(el => el.price === 0);
    const formUpdate = giftArrayProduct[0];
    let checkStep = document.querySelector(".step-progress.progress3").classList.contains("isChecked");
    if (giftArrayProduct.length === 2 && !checkStep) updateItem(formUpdate.id,0);
  }
  
  

// counter
const counterProducts = () => {
    let giftItems = document.querySelector('.gift--modal__items').dataset.totalPrice;

    let counter = 0;
    giftItems = parseInt(giftItems);
    if (giftItems > giftMinPriceAddedHigh) {
        counter = giftAddedHigh;
    }else if (giftItems > giftMinPriceAddedMedium) {
        counter = giftAddedMedium;
    }else if (giftItems > giftMinPriceAdded) {
        counter = giftAdded;
    }
    return counter;
}

//change cart items
function getAllCartItems() {
    toggleDisabledBtn(true)
    fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    })
    .then((response) => {
            return response.json();
    })
    .then((el) => {
        let updateData = {updates: {}}
        el.items.forEach((product, i, array) => {
            const exists = JsonObject.products.some((item) => parseInt(item.selected_variant) === parseInt(product.variant_id));
            if (exists) {
                updateData.updates[product.variant_id] = 0;
            }   
            if (i === el.items.length - 1) {
                removeItems(Object.keys(updateData)?.length, updateData);
            }
        });
    })
    .catch((error) => {
            console.error("Error:", error);
    })
    .finally(() => {
        setTimeout(toggleDisabledBtn(false), 1000);
    })
}

//remove items
function removeItems(length, giftCart) {
    const giftQuantityNew = document.querySelectorAll('.gift--modal__quantity .quantity_selector input');    
    if (length > 0) {
        // giftCart.forEach((gift, i)=>{
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(giftCart)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            setCartItems(giftQuantityNew);
        }).catch(function (err) {
        });
    } else {
        setCartItems(giftQuantityNew);
    }
}

//set cart items
function setCartItems(giftQuantityNew) {
    let giftArray = [];

    giftQuantityNew.forEach((quantity, i) => {
        let quantityId = quantity.id;
        let quantityValue = quantity.value;

        if (quantityValue !== 0) {
            let obj = {
                "id": quantityId,
                "quantity": quantityValue
            }
            giftArray.push(obj);
        }
    });
    let formData = {
        'items': giftArray
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            return response.json();
        })
        .then(() => {
            modalContent.classList.remove('in');
            getCartItems();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}

// modal plus minus
function plusItem(btn, modalQuantities, modalInputQuantities) {
    let valueQuantity = 0;
    let counter = counterProducts();

    modalInputQuantities.forEach((quantity, quantityIndex) => {
        valueQuantity += parseInt(quantity.value);
        giftSubtitle.innerHTML = valueQuantity;

        if (valueQuantity >= counter) {
            modalInputQuantities.forEach((quantityValue) => {
                if (+quantityValue.value === 0) {
                    // quantityValue.parentElement.parentElement.parentElement.classList.add('opacity__gift');
                } else {
                    quantityValue.nextElementSibling.setAttribute('disabled', 'true');
                }
            });
        }
    });
}

function minusItem(btn, modalQuantities, modalInputQuantities) {
    let giftItems = document.querySelector('.gift--modal__items').dataset.totalPrice;
    let counter = counterProducts();

    let valueQuantity = 0;
    let valueToString = '';
    modalInputQuantities.forEach((quantity, quantityIndex) => {
        valueQuantity -= parseInt(quantity.value);
        valueToString = valueQuantity.toString();
        giftSubtitle.innerHTML = valueToString.replace("-", "");

        if (valueQuantity <= counter) {
            modalInputQuantities.forEach((quantityValue) => {
                let dataMetafieldPrice = parseInt(quantityValue.parentElement.dataset.metafieldPrice);
                if (+quantityValue.value === 0) {
                    if (giftItems > dataMetafieldPrice) {
                        quantityValue.parentElement.parentElement.parentElement.classList.remove('opacity__gift');
                        quantityValue.nextElementSibling.removeAttribute('disabled');
                    }
                } else {
                    quantityValue.nextElementSibling.removeAttribute('disabled');
                }
            });
        }
    });
}

// let isDropdownActive = document.querySelector(
//   ".icart-coupon-code-svg.icart-add-coupon-code.isActive"
// );

// let discountInfo = document.querySelector(".sc_simple-info__row.sc_code-info");
// const handleChangeDiscoutnPosition = () => {
//   let infoInterval = setInterval(() => {
//     if (discountInfo) {
//       console.log("find info");

//       clearInterval(infoInterval);
//       document.querySelector(".discount_price_UT").appendChild(discountInfo);

//       document
//         .querySelector(".sc_code-btn")
//         .addEventListener("click", function () {
//           handleChangeDiscoutnPosition;
//         });
//     } else {
//       discountInfo = document.querySelector(
//         ".sc_simple-info__row.sc_code-info"
//       );
//     }
//   }, 500);
// };


// Progress bar 

function checkProgressBar() {
    const progressBars = document.querySelectorAll(".step-progress");
    const currentPriceCart = getPrice("#total_checkout_price");
  
    progressBars.forEach((item) => {
      const minValue = Number(item.getAttribute("data-min"));
      const maxValue = Number(item.getAttribute("data-max"));
  
      if (minValue < currentPriceCart) {
        item.setAttribute("value", getValueProgress(maxValue, currentPriceCart, item));
      } else {
        item.setAttribute("value", 0);
      }
  
      if (item.value == 0) {
        item.classList.remove("isChecked");
      }
    });
  
    if (currentPriceCart == "0") {
      progressBars.forEach((el) => el.classList.remove("isChecked"));
    }
  }


function getPrice(selector) {
    return (parseFloat(document.querySelector(selector).textContent) * 100).toFixed(0)
}

function getValueProgress(num1, num2, selector) {
    if (num2 > num1) {
      selector.classList.add("isChecked");
      return "100";
    } else {
      selector.classList.remove("isChecked");
      return String(((num2 * 100) / num1).toFixed(0) - 1);
    }
}

// Change Heading
// function changePriceHeading() {
//     let heading = document.querySelector(".cart_progress-title");
//     let titleSlides = document.querySelectorAll(".gift-title");
//     let markSlide = document.querySelectorAll(".gift-info");
//     let currentPriceCart = getPrice("#total_checkout_price");
//     let stepFirst = Number(heading.getAttribute("data-first"));
//     let stepSecond = Number(heading.getAttribute("data-second"));
//     let stepThird = Number(heading.getAttribute("data-third"));
//     let minProduct = Number(heading.getAttribute("data-min")) - 1;
//     let maxProduct = Number(heading.getAttribute("data-max"));
//     let currentSymbol =  document.querySelector("body").getAttribute("data-currencysymbol");
//     let stepCheck;
//     let stepCheckWithoutDelivery;
//     let headingText;
//     let titleSlide;
//     let passFreeDelivery;
//     let arrTexts = getTextProgress();
//     let giftsProduct = document.querySelectorAll(".cart_item[data-gift='true']").length;
//     let titleNotAvalible = document.querySelector(".title-not-avalible");
//     let titleIsAvalible = document.querySelector(".title-is-avalible");
//     let giftCount = document.querySelector(".gift--modal__counter");

//     if (stepFirst >= currentPriceCart) {
//         stepCheck = correctPrice(stepFirst,currentPriceCart,currentSymbol);
//         stepCheckWithoutDelivery = correctPrice(stepSecond,currentPriceCart,currentSymbol);
//         titleSlide = "";

//         headingText = arrTexts[0]["textDelivery"];
//         passFreeDelivery = false

//     } else if (stepFirst <= currentPriceCart && stepSecond >= currentPriceCart ) {

//         stepCheck = correctPrice(stepSecond,currentPriceCart,currentSymbol);
//         stepCheckWithoutDelivery = correctPrice(stepSecond,currentPriceCart,currentSymbol);

//         headingText = arrTexts[1]["textProductFirst"];
//         titleSlide = arrTexts[4]["stepTextTwo"];
//         passFreeDelivery = false

//     } else if (stepFirst <= currentPriceCart && stepSecond <= currentPriceCart && stepThird >= currentPriceCart  ) {

//         stepCheck = correctPrice(stepThird,currentPriceCart,currentSymbol);
//         stepCheckWithoutDelivery = correctPrice(stepSecond,currentPriceCart,currentSymbol);

//         headingText = arrTexts[2]["textProductSecond"];
//         titleSlide = arrTexts[5]["stepTextThree"];
//         passFreeDelivery = true
//         if (giftsProduct <= minProduct ) {
//             modalContent.classList.add('in');
//             confettiLoop() 
//         } 

//     } else if (stepFirst <= currentPriceCart && stepSecond <= currentPriceCart && stepThird <= currentPriceCart) {
       
//         headingText = arrTexts[3]["textSuccess"];
//         titleSlide = "";
//         passFreeDelivery = true
//         if (giftsProduct < maxProduct ) {
//             modalContent.classList.add('in');
//             confettiLoop() 
//         } 
//     }

//     heading.innerHTML = String(headingText).replace(/<span><\/span>/g, "<span>" + stepCheck + "</span>")


//     if (markSlide.length > 0) {
//         markSlide.forEach ( el => {
//             if (passFreeDelivery) {
//                 return el.innerHTML = String(headingText).replace(/<span>.*<\/span>/g, "<span>" + stepCheck  + "</span>") 
//             } else {
//                 return el.innerHTML = String(arrTexts[1]["textProductFirst"]).replace(/<span>.*<\/span>/g, "<span>" + stepCheckWithoutDelivery  + "</span>") 
//             }
//         })
//     }
//     if (titleSlides.length > 0) {
//         titleSlides.forEach ( el => el.innerHTML = titleSlide  )
//     }

//     if (passFreeDelivery) {
//         titleNotAvalible.classList.add("_hide");
//         giftCount.classList.remove("_hide");    
//         titleIsAvalible.classList.remove("_hide");
//     } else {
//         titleNotAvalible.classList.remove("_hide");
//         titleIsAvalible.classList.add("_hide");    
//         giftCount.classList.add("_hide"); 
//         titleNotAvalible.innerHTML = String(titleNotAvalible.innerHTML).replace(/<span>.*<\/span>/g, "<span>" + stepCheckWithoutDelivery + "</span>")
//     }

// }
function changePriceHeading() {
    const heading = document.querySelector(".cart_progress-title");
    const titleSlides = document.querySelectorAll(".gift-title");
    const markSlide = document.querySelectorAll(".gift-info");
    const currentPriceCart = getPrice("#total_checkout_price");
    const stepFirst = Number(heading.getAttribute("data-first"));
    const stepSecond = Number(heading.getAttribute("data-second"));
    const stepThird = Number(heading.getAttribute("data-third"));
    const minProduct = Number(heading.getAttribute("data-min")) - 1;
    const maxProduct = Number(heading.getAttribute("data-max"));
    const currentSymbol = document.querySelector("body").getAttribute("data-currencysymbol");
    const arrTexts = getTextProgress();
    const giftsProduct = document.querySelectorAll(".cart_item[data-gift='true']").length;
    const titleNotAvalible = document.querySelector(".title-not-avalible");
    const titleIsAvalible = document.querySelector(".title-is-avalible");
    const giftCount = document.querySelector(".gift--modal__counter");
  
    let stepCheck;
    let stepCheckWithoutDelivery;
    let headingText;
    let titleSlide;
    let passFreeDelivery;

    if (stepFirst >= currentPriceCart) {
      stepCheck = correctPrice(stepFirst, currentPriceCart, currentSymbol);
      stepCheckWithoutDelivery = correctPrice(stepSecond, currentPriceCart, currentSymbol);
      titleSlide = arrTexts[4]["stepTextTwo"];
      headingText = arrTexts[0]["textDelivery"];
      passFreeDelivery = false;
    } else if (stepFirst <= currentPriceCart && stepSecond >= currentPriceCart) {
      stepCheck = correctPrice(stepSecond, currentPriceCart, currentSymbol);
      stepCheckWithoutDelivery = correctPrice(stepSecond, currentPriceCart, currentSymbol);
      headingText = arrTexts[1]["textProductFirst"];
      titleSlide = arrTexts[4]["stepTextTwo"];
      passFreeDelivery = false;
    } else if (stepFirst <= currentPriceCart && stepSecond <= currentPriceCart && stepThird >= currentPriceCart) {
      stepCheck = correctPrice(stepThird, currentPriceCart, currentSymbol);
      stepCheckWithoutDelivery = correctPrice(stepSecond, currentPriceCart, currentSymbol);
      headingText = arrTexts[2]["textProductSecond"];
      titleSlide = arrTexts[5]["stepTextThree"];
      passFreeDelivery = true;
      if (giftsProduct <= minProduct) {
        modalContent.classList.add('in');
        confettiLoop();
      }
    } else if (stepFirst <= currentPriceCart && stepSecond <= currentPriceCart && stepThird <= currentPriceCart) {
      headingText = arrTexts[3]["textSuccess"];
      titleSlide = "";
      passFreeDelivery = true;
      if (giftsProduct < maxProduct) {
        modalContent.classList.add('in');
        confettiLoop();
      }
    }
  
    heading.innerHTML = String(headingText).replace(/<span><\/span>/g, "<span>" + stepCheck + "</span>");
  
    if (markSlide.length > 0) {
      markSlide.forEach(el => {
        if (passFreeDelivery) {
          el.innerHTML = String(headingText).replace(/<span>.*<\/span>/g, "<span>" + stepCheck + "</span>");
        } else {
          el.innerHTML = String(arrTexts[1]["textProductFirst"]).replace(/<span>.*<\/span>/g, "<span>" + stepCheckWithoutDelivery + "</span>");
        }
      });
    }
  
    if (titleSlides.length > 0) {
      titleSlides.forEach(el => (el.innerHTML = titleSlide));
    }
  
    if (passFreeDelivery) {
      titleNotAvalible.classList.add("_hide");
      giftCount.classList.remove("_hide");
      titleIsAvalible.classList.remove("_hide");
    } else {
      titleNotAvalible.classList.remove("_hide");
      titleIsAvalible.classList.add("_hide");
      giftCount.classList.add("_hide");
      titleNotAvalible.innerHTML = String(titleNotAvalible.innerHTML).replace(/<span>.*<\/span>/g, "<span>" + stepCheckWithoutDelivery + "</span>");
    }
  }
  


function correctPrice(priceStep, priceCart, symbol) {
  const priceDifference = (priceStep - priceCart) / 100;
  return priceDifference.toLocaleString(undefined, { minimumFractionDigits: 2 }) + symbol;
}

function getTextProgress() {
    let jsonText = document.querySelector(".text-progress").innerHTML.trim();
    let json = JSON.parse(jsonText);
    if (json) {
        return json
    } else {
        return false
    }
}
// Progress bar 


// Check delivery 
function checkDelivery() {
    let fieldDelivery = document.querySelector(".checkout_table");
    let currentPriceCart = getPrice("#total_checkout_price");
    let pointFreeDelivery = Number(fieldDelivery.querySelector("#deliveryInfo").getAttribute("data-delivery"));
    if (pointFreeDelivery >= currentPriceCart) {
        fieldDelivery.classList.add("hide")
    } else {
        fieldDelivery.classList.remove("hide")
    }
}

// Checkbox fake PopUp
function handleCheckbox(event) {
    let wrapSelectProduct = document.querySelector(".select_product");
    let giftModal = document.querySelector(".gift--modal__items");
    let modeSelect = giftModal.getAttribute("data-mode-select");
    let checkboxs = document.querySelectorAll(".checkbox_fake");
    let currentFakeCheckbox = event.querySelector(".checkbox_fake");
    let flag = currentFakeCheckbox.classList.contains("isChecked");
    let itemWrap, minusItem, plusItem;

    switch (modeSelect) {
        case "single":
            checkboxs.forEach (el => {
                itemWrap = el.closest(".gift--modal__item ");
                minusItem = itemWrap.querySelector("[name='minus']")
                plusItem = itemWrap.querySelector("[name='plus']")
                if (el == currentFakeCheckbox) {
                    el.classList.toggle("isChecked");
                    !flag ? plusItem.dispatchEvent(new Event('click')) : minusItem.dispatchEvent(new Event('click'));
                } else {
                    el.classList.remove("isChecked");
                    minusItem.dispatchEvent(new Event('click'));
                }
            }) 
            break;
        case "multi":
            itemWrap = currentFakeCheckbox.closest(".gift--modal__item ");
            minusItem = itemWrap.querySelector("[name='minus']")
            plusItem = itemWrap.querySelector("[name='plus']")
            currentFakeCheckbox.classList.toggle("isChecked");
            !flag ? plusItem.dispatchEvent(new Event('click')) : minusItem.dispatchEvent(new Event('click'));
            break;
        default:
            break;
    }
    getSelectProduct(wrapSelectProduct, document.querySelectorAll(".checkbox_fake.isChecked"));
    checkCountSelectProduct();
    removeDisabledBtn()
}


function checkGiftProductIsCart(id) {
    let nameClass = ""
    let giftsProductCart = document.querySelectorAll(".cart_item[data-gift='true']");
    if (giftsProductCart.length != 0) {
        [...giftsProductCart].filter( el => {
            if (el.getAttribute("data-id") == id) {
            nameClass = "is-cart-product"
            } else {
            nameClass = ""
            }
        })
    }

    return nameClass
}


function removeDisabledBtn() {
    let selectProduct = document.querySelector(".select_product").textContent;
    let maxProduct = document.querySelector(".select_max").textContent;
    if (+selectProduct === +maxProduct ) {
        document.querySelector(".add__products").removeAttribute("disabled");
    } else {
        document.querySelector(".add__products").setAttribute("disabled", "true");
    }
}

function checkCountSelectProduct() {
    let checkBoxsCheck = document.querySelectorAll(".checkbox_fake.isChecked").length;
    let notBoxsCheck = document.querySelectorAll(".checkbox_fake:not(.isChecked)");
    let modeSelect = document.querySelector(".gift--modal__items").getAttribute("data-mode-select");
    let minProduct =  Number(document.querySelector(".gift--modal__items").getAttribute("data-added-medium"));
    let maxProduct =  Number(document.querySelector(".gift--modal__items").getAttribute("data-added-high"));
    switch (modeSelect) {
        case "single":
            if (checkBoxsCheck === minProduct) {
                notBoxsCheck.forEach(el => {
                    el.closest('.gift--modal__item').classList.add("hides")
                })
            } else {
                notBoxsCheck.forEach(el => {
                    el.closest('.gift--modal__item').classList.remove("hides")
                })
            }
            break;
        case "multi":
            if (checkBoxsCheck === maxProduct) {
                notBoxsCheck.forEach(el => {
                    el.closest('.gift--modal__item').classList.add("hides")
                })
            }else {
                notBoxsCheck.forEach(el => {
                    el.closest('.gift--modal__item').classList.remove("hides")
                })
            }
            break;
        default:
            break;
    }
}

function getSelectProduct(selector, htmlCollection) {
    selector.textContent  = htmlCollection.length;
}

function toggleModeSelect() {
    let giftModal = document.querySelector(".gift--modal__items");
    let singleProduct = Number(giftModal.getAttribute("data-added-price-medium"));
    let multiProduct = Number(giftModal.getAttribute("data-added-price-high"));
    let currentPrice = Number(giftModal.getAttribute("data-total-price"));
    let minProduct = Number(giftModal.getAttribute("data-added"));
    let mediumProduct = Number(giftModal.getAttribute("data-added-medium"));
    let maxProduct = Number(giftModal.getAttribute("data-added-high"));
    let wrapMaxProduct = document.querySelector(".select_max");
    if ( (singleProduct <= currentPrice) &&  (multiProduct >= currentPrice) ) {
        giftModal.setAttribute("data-mode-select", "single");
        wrapMaxProduct.textContent = mediumProduct;
    } else if( (singleProduct <= currentPrice) &&  (multiProduct <= currentPrice) ) {
        giftModal.setAttribute("data-mode-select", "multi");
        wrapMaxProduct.textContent = maxProduct;
    }
}

// Confetti

const confetti = document.getElementById('confetti');
const confettiCtx = confetti.getContext('2d');
let containerConfetti, confettiElements = [], clickPosition;
rand = (min, max) => Math.random() * (max - min) + min;

const confettiParams = {
    number: 70,
    size: { x: [5, 20], y: [10, 18] },
    initSpeed: 25,
    gravity: 0.65,
    drag: 0.08,
    terminalVelocity: 6,
    flipSpeed: 0.017,
};
const colors = [
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' },
    { front: '#BD7C08', back: '#E2D223' }

];

setupCanvas();
updateConfetti();

window.addEventListener('resize', () => {
    setupCanvas();
    hideConfetti();
});

function Conf() {
    this.randomModifier = rand(-1, 1);
    this.colorPair = colors[Math.floor(rand(0, colors.length))];
    this.dimensions = {
        x: rand(confettiParams.size.x[0], confettiParams.size.x[1]),
        y: rand(confettiParams.size.y[0], confettiParams.size.y[1]),
    };
    this.position = {
        x: clickPosition[0],
        y: clickPosition[1]
    };
    this.rotation = rand(0, 2 * Math.PI);
    this.scale = { x: 1, y: 1 };
    this.velocity = {
        x: rand(-confettiParams.initSpeed, confettiParams.initSpeed) * 0.4,
        y: rand(-confettiParams.initSpeed, confettiParams.initSpeed)
    };
    this.flipSpeed = rand(0.2, 1.5) * confettiParams.flipSpeed;

    if (this.position.y <= containerConfetti.h) {
        this.velocity.y = -Math.abs(this.velocity.y);
    }

    this.terminalVelocity = rand(1, 1.5) * confettiParams.terminalVelocity;

    this.update = function () {
        this.velocity.x *= 0.98;
        this.position.x += this.velocity.x;

        this.velocity.y += (this.randomModifier * confettiParams.drag);
        this.velocity.y += confettiParams.gravity;
        this.velocity.y = Math.min(this.velocity.y, this.terminalVelocity);
        this.position.y += this.velocity.y;

        this.scale.y = Math.cos((this.position.y + this.randomModifier) * this.flipSpeed);
        this.color = this.scale.y > 0 ? this.colorPair.front : this.colorPair.back;
    }
}

function updateConfetti() {
    confettiCtx.clearRect(0, 0, containerConfetti.w, containerConfetti.h);

    confettiElements.forEach((c) => {
        c.update();
        confettiCtx.translate(c.position.x, c.position.y);
        confettiCtx.rotate(c.rotation);
        const width = (c.dimensions.x * c.scale.x);
        const height = (c.dimensions.y * c.scale.y);
        confettiCtx.fillStyle = c.color;
        confettiCtx.fillRect(-0.5 * width, -0.5 * height, width, height);
        confettiCtx.setTransform(1, 0, 0, 1, 0, 0)
    });

    confettiElements.forEach((c, idx) => {
        if (c.position.y > containerConfetti.h ||
            c.position.x < -0.5 * containerConfetti.x ||
            c.position.x > 1.5 * containerConfetti.x) {
            confettiElements.splice(idx, 1)
        }
    });
    window.requestAnimationFrame(updateConfetti);
}

function setupCanvas() {
    containerConfetti = {
        w: confetti.clientWidth,
        h: confetti.clientHeight
    };
    confetti.width = containerConfetti.w;
    confetti.height = containerConfetti.h;
}

function addConfetti(e) {
    const canvasBox = confetti.getBoundingClientRect();
    if (e) {
        clickPosition = [
            e.clientX - canvasBox.left,
            e.clientY - canvasBox.top
        ];
    } else {
        clickPosition = [
            canvasBox.width * Math.random(),
            canvasBox.height * Math.random()
        ];
    }
    for (let i = 0; i < confettiParams.number; i++) {
        confettiElements.push(new Conf())
    }
}

function hideConfetti() {
    confettiElements = [];
    window.cancelAnimationFrame(updateConfetti)
}

function confettiLoop() {
    let count = 0
    let timer = setInterval( () => {
        addConfetti();
        count = count + 1
        if (count === 3) clearInterval(timer) 
    }, 750)
}
// Check gift product
function checkGiftProduct() {
    let giftsProduct = document.querySelectorAll(".cart_item[data-gift='true']")
    giftsProduct.forEach( el => {
        let idSelectror = el.getAttribute("data-id");
        let productModal = document.querySelector(`.gift--modal__item[data-id="${idSelectror}"]`);
        productModal.dispatchEvent(new Event('click'));
    })
}

// deleteGiftProduct

function deleteGiftProductWithModal() {
    let giftProductCart = document.querySelectorAll(".cart_item[data-gift='true']");
    let giftProductModal = document.querySelectorAll(".gift--modal__item");
    let flag = document.querySelector(".gift--modal__counter").classList.contains("_hide");
    if (giftProductCart.length === 0 && flag) {
        giftProductModal.forEach(el => {
            el.classList.add("hides");
            el.classList.remove("is-cart-product");
            el.querySelector(".checkbox_fake").classList.remove("isChecked");
        })
    }
}

function isCartModalProduct(id) {
    let giftProductCart = document.querySelectorAll(".cart_item[data-gift='true']");
    if (giftProductCart.length != 0) {
        [...giftProductCart].filter(el =>{
            if (+el.dataset.id === +id) {
                return true
            } else {
                return false
            }
        })
    }
    
}

function checkItemInCart() {
    let giftProductCart = document.querySelectorAll(".cart_item[data-gift='true']");
    if (giftProductCart.length != 0) {
        giftProductCart.forEach(el => {
            document.querySelector(`.gift--modal__item[data-id='${el.dataset.id}']`).classList.add("is-cart-product")
        })
    }
}

function getFakePrice(id) {
    let currentProduct = JsonObject.products.filter( el => el["selected_variant"] == String(id));
    return currentProduct[0]["metafield_fake"] != "" ?  currentProduct[0]["metafield_fake"] + currencySymbol : "29.00" + currencySymbol;
}

function toggleDisabledBtn(disabled) {
    btnCheckout.style.pointerEvents = disabled ? "none" : ""
}